import { Wizard } from "./Wizard";

export function NuevaPage() {
  return <Wizard />;
}
